import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './styles/global-minimal.css';

// Daily Archive App - Main Entry Point

// 全局数据导出导入函数
window.exportData = async (items, categories) => {
  try {
    const data = {
      items: items,
      categories: categories,
      export_date: new Date().toISOString(),
      version: '2.0'
    };

    const dataStr = JSON.stringify(data, null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `mindmap-items-${new Date().toISOString().split('T')[0]}.json`;
    link.click();
    URL.revokeObjectURL(url);
    
    alert('数据导出成功！');
  } catch (error) {
    console.error('导出失败:', error);
    alert('导出失败: ' + error.message);
  }
};

window.importData = async (event, onRefresh) => {
  const file = event.target.files[0];
  if (!file) return;

  try {
    const text = await file.text();
    const data = JSON.parse(text);
    
    const { db, auth } = await import('./supabaseClient');
    const user = await auth.getCurrentUser();
    
    if (!user) {
      alert('用户未登录');
      return;
    }

    let importCount = 0;
    let updateCount = 0;

    // 导入分类
    if (data.categories) {
      for (const category of data.categories) {
        try {
          await db.addCategory({
            ...category,
            user_id: user.id
          });
          importCount++;
        } catch (error) {
          // 分类可能已存在，忽略错误
        }
      }
    }

    // 导入物品
    if (data.items) {
      for (const item of data.items) {
        try {
          const itemData = {
            ...item,
            user_id: user.id,
            purchase_price: item.purchase_price ? parseFloat(item.purchase_price) : null
          };
          
          // 检查是否已存在（品牌+名称）
          const existingItems = await db.getItems(user.id);
          const existing = existingItems.data?.find(
            existing => existing.brand === item.brand && existing.name === item.name
          );

          if (existing) {
            // 覆盖现有数据
            await db.updateItem(existing.id, itemData);
            updateCount++;
          } else {
            // 添加新数据
            await db.addItem(itemData);
            importCount++;
          }
        } catch (error) {
          console.error('导入物品失败:', error);
        }
      }
    }

    alert(`导入完成！新增 ${importCount} 项，更新 ${updateCount} 项`);
    onRefresh();
    
    // 清空文件输入
    event.target.value = '';
  } catch (error) {
    console.error('导入失败:', error);
    alert('导入失败: ' + error.message);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
